import { createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/image/iconRight.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-2980716e")

_pushScopeId("data-v-2980716e")
const _hoisted_1 = { class: "ui__ensureService_main" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 服务保障说明 ")
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "icon_right"
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: "ui__ensureService_title",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toView && _ctx.toView(...args)))
    }, [
      _hoisted_2,
      _hoisted_3
    ])
  ]))
})